import Actions from '../constants/Actions';
import Immutable from 'immutable';

const extractName = r => r.name;

function hasComponent(route) {
  return route.component || route.getComponent || route.components;
}

async function getComponentForRoute(route, state) {
  let component = route.component || route.components;
  if (route.getComponent) {
    component = await route.getComponent(state);
  }

  console.info('Obtained component', {
    route,
    state,
    component
  });
  return {
    ...route,
    component
  };
}

async function getRouteComponents(routes, state) {
  const routesWithComponents = await Promise.all(routes.map(r => {
    return getComponentForRoute(r, state);
  }));

  console.info('Obtained components', routesWithComponents);
  return routesWithComponents;
}

export default async function (actionContext, state) {
  const payload = {
    params: state.params,
    query: state.location.query || {}
  };

  try {
    const routeStore = actionContext.getStore('RouteStore');
    const currentRoutes = (routeStore.getCurrentRoutes() || Immutable.Seq()).toOrderedSet();
    const newRoutes = Immutable.OrderedSet(state.routes);

    const routesToSearch = newRoutes.map(extractName).subtract(currentRoutes);
    actionContext.dispatch(Actions.NAVIGATION__STARTED, state);
    const routesWithComponents = await getRouteComponents(
      newRoutes
        .filter(r => routesToSearch.contains(r.name))
        .filter(hasComponent),
      state
    );

    const handlersToRun = routesWithComponents.filter(r => r.component.loadAction);

    await Promise.all(handlersToRun.map(route => {
      console.info('Executing loadAction', {
        route
      });

      return actionContext.executeAction(route.component.loadAction, payload);
    }));

    actionContext.dispatch(Actions.NAVIGATION__COMPLETED, state);
  } catch (err) {
    console.error('Error performing navigation', err);
    actionContext.dispatch(Actions.NAVIGATION__FAILED, err);

    throw(err);
  }
}



// WEBPACK FOOTER //
// ./src/actions/navigateAction.js